import type React from "react";

import {createIcon, Icon as IconNext} from "../../../components/ui/icon";

// the loader on web exports `ReactComponent` whearas on native it exports `default` as component
// not sure there's a better way to write this more nicely
export const iconBuilder = (
    // support for both web and native how they resolve svg
    value:
        | React.ComponentType<unknown>
        | {
              default: string | React.ComponentType<React.SVGProps<unknown>>;
              ReactComponent: React.ComponentType<React.SVGProps<unknown>>;
          },
    displayName: string,
    viewBox: string
) => {
    const Root =
        "default" in value
            ? typeof value.default !== "string"
                ? value.default
                : value.ReactComponent
            : value;
    const IconInternal = createIcon<React.SVGProps<unknown>>({
        Root,
        viewBox
    });

    // IconInternal.displayName = displayName;
    // return IconInternal;

    const IconComponent = (props: React.ComponentProps<typeof IconNext>) => {
        return <IconNext as={IconInternal} {...props} />;
    };
    IconComponent.displayName = displayName;
    return IconComponent;
};
